import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../Utils/axios";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import Switch from "react-switch";
import MultiSelect from "react-multi-select-component";

function AddUser() {
  const history = useHistory();
  const [user, setUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState([]);
  const alert = useAlert();
  useEffect(() => {
    getUserRoles();
    getMainCategories();
  }, []);
  const getMainCategories = () => {
    setLoading(true);
    axios(`Users/get_main_category`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((res) => {
        if (res.data.error === true) {
          setLoading(false);
        } else {
          if (!res.data.status) {
          } else {
            setCategories(res.data.data);
            setLoading(false);
          }
        }
      })
      .catch((err) => console.log(err));
  };
  const userAdd = (event) => {
    event.preventDefault();
    setLoading(true);
    let formdata = new FormData();
    formdata.append("name", user.name);
    formdata.append("email", user.email);
    formdata.append("user_role", user.user_role);
    formdata.append("status", user.status);
    formdata.append("category", JSON.stringify(selected));
    axios(`Users/add_seller_user`, {
      method: "POST",
      data: formdata,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((res) => {
        if (res.data.status) {
          setLoading(false);
          history.push({
            pathname: "/users",
            state: { data: true },
          });
        } else {
          setLoading(false);
          alert.show(res.data.message);
        }
      })
      .catch((err) => console.log(err));
  };

  const getUserRoles = () => {
    setLoading(true);
    axios(`Users/get_user_roles`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": JSON.parse(localStorage.getItem("data")),
      },
    })
      .then((res) => {
        if (!res.data.status) {
          setLoading(false);
        } else {
          setLoading(false);
          setRoles(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <LoadingOverlay
      active={loading}
      styles={{
        overlay: (base) => ({
          ...base,
          background: "rgba(255, 255, 255, 0.9)",
        }),
        spinner: (base) => ({
          ...base,
          width: "75px",
          "& svg circle": {
            stroke: "rgba(0, 0, 0, 0.8)",
          },
        }),
      }}
      spinner
      text="Loading ..."
    >
      <div>
        <div class="card">
          <form>
            <div class="form-group">
              <label htmlFor="Email">Email</label>
              <input
                type="email"
                class="form-control"
                value={user.email}
                onChange={(e) =>
                  setUser({
                    ...user,
                    email: e.target.value,
                  })
                }
                id="Email"
                placeholder="Email"
              />
            </div>
            <div class="form-group">
              <label htmlFor="Name">Name</label>
              <input
                type="text"
                class="form-control"
                value={user.name}
                onChange={(e) =>
                  setUser({
                    ...user,
                    name: e.target.value,
                  })
                }
                id="Name"
                placeholder="Name"
              />
            </div>

            <div class="form-group ">
              <label htmlFor="Role">Role</label>
              <select
                class="form-control"
                onChange={(e) =>
                  setUser({
                    ...user,
                    user_role: e.target.value,
                  })
                }
                id="Role"
              >
                <option value="">Select Roles</option>
                {roles.map((value) => {
                  return (
                    <option value={value.id} key={value.id}>
                      {value.role_name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div class="form-group ">
              <label>Category</label>

              <MultiSelect
                options={categories}
                value={selected}
                onChange={setSelected}
                labelledBy={"Select"}
              />
            </div>

            <div class="form-group ">
              <Switch
                onChange={(e) =>
                  setUser({
                    ...user,
                    status: e ? 1 : 0,
                  })
                }
                checked={user.status == 1 ? 1 : 0}
              />
            </div>

            <button type="button" onClick={userAdd} class="btn btn-primary">
              Submit
            </button>
          </form>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default AddUser;
